import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class StockistsCallout {
    constructor(container) {
        this.container = container;
        this.body = container.querySelector('.stockists-callout__body');
        this.init();
    }

    init = () => {
        if (!this.body) return;

        this.bodySplit = new SplitText(this.body, { type: 'lines,words', linesClass: 'lineParent' });

        gsap.fromTo(
            this.bodySplit.words,
            { yPercent: 100 },
            {
                yPercent: 0,
                duration: 0.6,
                stagger: { each: 0.03, ease: 'power.out', from: 'start' },
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: this.body,
                    start: 'top 85%',
                },
                onComplete: () => {
                    this.onBodyResize();
                },
            }
        );
    }

    onBodyResize = () => {
        this.bodySplit?.revert();
    }
}
